import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengerInputInformationComponent } from './passenger-input-information.component';
import { ButtonModule } from '@lib/components';
import { DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { ContactInformationToUsModule } from '../contact-information-to-us/contact-information-to-us.module';
import { PassportInformationModule } from '../passport-information/passport-information.module';
import { FfpInformationModule } from '../ffp-information/ffp-information.module';
import { ContactInformationModule } from '../contact-information/contact-information.module';
import { ImmigrationInformationModule } from '../immigration-information/immigration-information.module';

@NgModule({
  declarations: [PassengerInputInformationComponent],
  imports: [
    CommonModule,
    ButtonModule,
    StaticMsgModule,
    DateFormatModule,
    ContactInformationToUsModule,
    PassportInformationModule,
    FfpInformationModule,
    ContactInformationModule,
    ImmigrationInformationModule,
  ],
  exports: [PassengerInputInformationComponent],
})
export class PassengerInputInformationModule {}
